import normalizeFederalTaxNumber from './normalizeFederalTaxNumber';

const formatFederalTaxNumber = (federalTaxNumber) => {
  if (!federalTaxNumber) {
    return '';
  }

  const normalized = normalizeFederalTaxNumber(federalTaxNumber);

  if (!normalized) {
    return '';
  }

  const hasCaracter = () => {
    const regex = /[a-zA-Z]/;
    return regex.test(federalTaxNumber);
  };

  if (normalized.length === 14) {
    return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(
      5,
      8
    )}/${normalized.slice(8, 12)}-${normalized.slice(12, 14)}`;
  }

  if (normalized.length === 11 && !hasCaracter()) {
    return `${normalized.slice(0, 3)}.${normalized.slice(3, 6)}.${normalized.slice(
      6,
      9
    )}-${normalized.slice(9, 11)}`;
  }

  return federalTaxNumber;
};

export default formatFederalTaxNumber;
